import axios from 'axios';
import { StoreApi } from 'zustand';

import {
  getShopifyAxiosConfig,
  getShopifyGqlEndpoint,
  getShopifyUrlAndToken,
} from '../../shopify';
import { CustomerStore } from './useCustomer';

const query = `
mutation customerAccessTokenCreate(
  $input: CustomerAccessTokenCreateInput!
) {
  customerAccessTokenCreate(input: $input) {
    customerAccessToken {
      accessToken
      expiresAt
    }
    customerUserErrors {
      code
      field
      message
    }
  }
}`;

export function login(
  set: StoreApi<CustomerStore>['setState'],
  get: StoreApi<CustomerStore>['getState'],
): (input: { email: string; password: string }) => Promise<void> {
  return async (input: { email: string; password: string }) => {
    try {
      const { token } = getShopifyUrlAndToken();
      const shopifyGqlEndpoint = getShopifyGqlEndpoint();
      const shopifyAxiosConfig = getShopifyAxiosConfig(token);

      const tokenRequest = await axios.post(
        shopifyGqlEndpoint,
        {
          query,
          variables: { input },
        },
        shopifyAxiosConfig,
      );

      const customerLoginError =
        tokenRequest?.data?.errors?.[0]?.message ||
        tokenRequest?.data?.data?.customerAccessTokenCreate
          ?.customerUserErrors?.[0]?.message;

      if (customerLoginError !== undefined) {
        throw new Error(customerLoginError);
      }

      const customerAccessToken =
        tokenRequest?.data?.data?.customerAccessTokenCreate
          ?.customerAccessToken;

      if (customerAccessToken) {
        set({
          customerAccessToken,
          customerLoginError: undefined,
        });

        get().___fetchCustomer();
      }
    } catch (err) {
      console.error(err);
      // @ts-expect-error err isn't typed
      set({ customerLoginError: err.message });
    }
  };
}
